import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { PricesTablePanelComponent } from "./prices-table-panel.component";
import { SharedModule } from "src/app/shared/shared.module";
import { PricesTableCategoryItemModule } from "./components/prices-table-category-item/prices-table-category-item.module";
import { PricesTableLicenseItemModule } from "./components/prices-table-license-item/prices-table-license-item.module";

@NgModule({
  declarations: [PricesTablePanelComponent],
  exports: [PricesTablePanelComponent],
  imports: [
    CommonModule,
    SharedModule,
    PricesTableLicenseItemModule,
    PricesTableCategoryItemModule,
  ],
})
export class PricesTablePanelModule {}
